import React from 'react'
// nodejs library to set properties for components
import PropTypes from 'prop-types'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import Hidden from '@material-ui/core/Hidden'
import Grid from '@material-ui/core/Grid'

//icon
import Img from 'gatsby-image'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const style = theme => ({
  icon: {
    color: theme.palette.primary.main,
  },
})

const IconList = ({ classes, icon, image, list }) => {
  return (
    <Grid container alignItems="center" spacing={24}>
      <Hidden smDown>
        <Grid item md={3}>
          {icon && (
            <FontAwesomeIcon icon={icon} size="8x" className={classes.icon} />
          )}
          {image && (
            <Img
              title="Adrien POLY"
              alt="Adrien POLY"
              fixed={image.childImageSharp.fixed}
              critical={true}
            />
          )}
        </Grid>
      </Hidden>
      <Grid item md={9}>
        {list}
      </Grid>
    </Grid>
  )
}

IconList.propTypes = {
  classes: PropTypes.object,
  icon: PropTypes.element,
  image: PropTypes.object,
  list: PropTypes.array.isRequired,
}

export default withStyles(style)(IconList)
